/* Contact page — same client-side validation as the approved source, then a REAL native Shopify contact form POST. */
(function () {
  var form = document.getElementById('contact-form');
  var submit = document.getElementById('contact-submit');
  if (!form) return;
  form.setAttribute('aria-label', 'Contact form');

  function validateField(input, errorId, checkFn) {
    var errorEl = document.getElementById(errorId);
    var valid = checkFn(input.value.trim());
    input.classList.toggle('is-error', !valid);
    if (errorEl) errorEl.classList.toggle('is-visible', !valid);
    return valid;
  }
  function isNonEmpty(v) { return v.length > 0; }
  function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
  function isMessage(v) { return v.length >= 10; }

  var nameInput = document.getElementById('contact-name');
  var emailInput = document.getElementById('contact-email');
  var messageInput = document.getElementById('contact-message');

  if (nameInput) nameInput.addEventListener('blur', function () { validateField(nameInput, 'contact-name-error', isNonEmpty); });
  if (emailInput) emailInput.addEventListener('blur', function () { validateField(emailInput, 'contact-email-error', isEmail); });
  if (messageInput) messageInput.addEventListener('blur', function () { validateField(messageInput, 'contact-message-error', isMessage); });

  form.addEventListener('submit', function (e) {
    // Honeypot check
    var honeypot = form.querySelector('input[name="website"]');
    if (honeypot && honeypot.value.length > 0) { e.preventDefault(); return; }

    var nameOk = validateField(nameInput, 'contact-name-error', isNonEmpty);
    var emailOk = validateField(emailInput, 'contact-email-error', isEmail);
    var messageOk = validateField(messageInput, 'contact-message-error', isMessage);

    if (!nameOk || !emailOk || !messageOk) {
      e.preventDefault();
      if (!nameOk) nameInput.focus();
      else if (!emailOk) emailInput.focus();
      else if (!messageOk) messageInput.focus();
      return;
    }
    // Valid: let the browser POST to Shopify (native contact form). Show the source's "Sending…" state.
    if (submit) {
      submit.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke-dasharray="60" stroke-dashoffset="60" style="animation:spin 1s linear infinite"><animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/></circle></svg> Sending…';
      setTimeout(function () { submit.disabled = true; }, 0); // disable after the submit event so the POST still fires
    }
  });

  // Server-rendered success: scroll the confirmation into view like the source did
  var success = document.getElementById('form-success');
  if (success && success.classList.contains('is-visible')) success.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
})();